import React, {useEffect, useState} from "react";
import Button from "../baseComponents/gui/button/Button";
import buttonStyles from "../baseComponents/gui/button/Button.module.scss";
import {safeHTML} from "../../utils/safeHTML";
import Countdown from "react-countdown";
import {rendererTimeGame} from "../../utils/data/rendererTime";
import Icon from "../baseComponents/gui/icon/Icon";
import {rendererPrice} from "../../utils/data/rendererPrice";
import styles from "./CurrentCirculations.module.scss";
import classNames from "classnames";
import Image from "next/image";

const CurrentCirculationsItem = React.forwardRef(
  function CurrentCirculationsItem(props, ref) {
    const {superPrizeDate: date, image, superImage, link, cost, superPrize: prize, index} = props;
    const [render, setRender] = useState(false);

    useEffect(() => {
      setRender(true)
    }, []);

    return (
      <a
        href={link}
        target={"_blank"}
        className={styles.currentCirculations__item} ref={ref}>

        <span className={styles.currentCirculations__itemIcon}>
          <Image
            src={image}
            alt="name"
            width={139}
            height={56}
            loading={index < 4 ? "eager" : "lazy"}
          />
        </span>
        {date && <span className={styles.currentCirculations__itemTimer}>
                   <span className={styles.currentCirculations__itemTimerIcon}>
                   <Icon name={"time"}/>
          </span>
          {render && <Countdown date={new Date(date * 1000)}
                                renderer={rendererTimeGame}
          />}
      </span>
        }
        <span className={styles.currentCirculations__itemPrize}>
          <span>{`Суперприз`}</span><span>{safeHTML(rendererPrice(prize))} ₽</span>
        </span>
        <span className={styles.currentCirculations__itemPrice}>{safeHTML(cost)}₽</span>
        <Button tag={"span"}
                className={classNames(
                  buttonStyles.button_yellow,
                  buttonStyles.button_mini,
                  styles.currentCirculations__itemButton
                )}>
          {`Купить`}
        </Button>

      </a>
    );
  });
export default CurrentCirculationsItem;
CurrentCirculationsItem.propTypes = {};

